import { Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatTime } from "~/modules/app/util/formatters";

interface TimelineItemTimeProps {
    startTime: string;
    endTime?: string | null;
}

export function TimelineItemTime({ startTime, endTime }: TimelineItemTimeProps) {
    return (
        <Stack justifyContent="space-between">
            <Stack alignItems="center" sx={theme => ({ backgroundColor: theme.palette.background.paper })}>
                <Typography>{formatTime(parseStringToDate(startTime))}</Typography>
            </Stack>
            {endTime && (
                <Typography sx={theme => ({ backgroundColor: theme.palette.background.paper })}>
                    {formatTime(parseStringToDate(endTime))}
                </Typography>
            )}
        </Stack>
    );
}
